import { cancelChaangeOrderDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getcancelChaangeOrderEn = () => {
  const data = cancelChaangeOrderDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addcancelChaangeOrderRequest = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-cancel-my-service-change-order`,
    ) &&
    document.getElementById(`cancelChaangeOrderJSONLD`) === null
  ) {
    const script = cancelChaangeOrderJSONLDEn()
    addJSONLDToHead(script, `cancelChaangeOrderJSONLD`)
  } else {
    removeElement(`cancelChaangeOrderJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const cancelChaangeOrderJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getcancelChaangeOrderEn(),
  }
  return FaqBagsterTemplate
}
